import { Component, OnDestroy, Input, ViewChild } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { BehaviorSubject, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { VoiceService } from '../voice.service';
import {
  ToasterPosition,
  ToasterService,
} from 'src/app/shared/services/toaster/toaster.service';
import { IVoice } from 'src/app/talent-litmus-core/game-core/level1-core/voice-core';
import { VoiceFormComponent } from '../voice-form/voice-form.component';

@Component({
  selector: 'app-edit-voice',
  templateUrl: './edit-voice.component.html',
})
export class EditVoiceComponent implements OnDestroy {
  private _unsubscribe$ = new Subject<void>();
  @ViewChild(VoiceFormComponent) voiceFormComponent: VoiceFormComponent;
  isUploadDone = false;
  @Input()
  public voice: IVoice;
  editing$ = new BehaviorSubject<boolean>(false);
  isInvalid: boolean;

  constructor(
    public modal: NgbActiveModal,
    private _voiceService: VoiceService,
    private _toasterService: ToasterService,
  ) {}

  submit(): void {
    const data = this.voiceFormComponent.onSubmit();
    this.editing$.next(true);
    this._voiceService
      .editVoice(data)
      .pipe(takeUntil(this._unsubscribe$))
      .subscribe(
        () => {
          this.editing$.next(false);
          this._toasterService.showSuccess(
            'Voice updated successfully',
            ToasterPosition.topRightSticky,
          );
          this.modal.close(true);
          this._voiceService.setSelectedId(data?._id);
        },
        (err) => {
          console.log(err);
          this.editing$.next(false);
          this._toasterService.showError(
            err?.error?.message,
            ToasterPosition.topRightSticky,
          );
        },
      );
  }

  onValidityChange(validity?: boolean): void {
    this.isInvalid = validity;
  }

  uploadChange(res: boolean): void {
    this.isUploadDone = res;
  }

  ngOnDestroy(): void {
    this._unsubscribe$.next();
    this._unsubscribe$.complete();
  }
}
